export default "__VITE_ASSET__ChYA$Ig2__"